var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('urun-listesi-ekle',{attrs:{"duzenle":_vm.listeDetay},on:{"clear":_vm.duzenleSifirla}})}
var staticRenderFns = []

export { render, staticRenderFns }